import DE from "./de-DE"
import EN from "./en-EN"

const Resources ={
  de: {
    translation: DE   
  },
  en: {
    translation: EN
  }
}

export default Resources